<template>
  <section class="accomplishments">
    <h2 class="accomplishments__title">Expertise & Accomplishments</h2>
    <div class="accomplishments__accordion">
      <div v-for="(item, index) in accordionData" :key="index" class="accomplishments__accordion-item">
        <div class="accomplishments__accordion-item-header" @click="toggleAccordion(index)" :class="{ 'is-open': isOpen(index) }">
          <h3>
            <button :aria-label="`${item.title}, ${isOpen(index) ? 'expanded' : 'collapsed'}`" role="button">
              <span class="accomplishments__accordion-item-header--title">{{ item.title }}</span>
              <span :class="{ 'rotate': isOpen(index) }" class="chevron">
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="14" viewBox="0 0 25 14" fill="none">
                  <path d="M12.5 14L11.8418 13.3331L0.658204 2.00084L1.10731e-06 1.33389L1.3164 -2.07049e-06L1.9746 0.666946L12.5 11.3322L23.0254 0.666948L23.6836 -1.15084e-07L25 1.3339L24.3418 2.00084L13.1582 13.3331L12.5 14Z" fill="black"/>
                  </svg>
              </span>
            </button>
          </h3>
          <!-- <h3 class="accomplishments__accordion-item--title">{{ item.title }}</h3> -->
        </div>
        <transition class="accordion-slide" name="fade">
          <ul v-if="isOpen(index)" class="accomplishments__accordion-item-content" :aria-labelledby="`accordion-header - ${index}`">
            <li class="accomplishments__accordion-item-content--item" v-for="(listItem, index) in item.content" :key="index">
              <!-- <span>{{ listItem }}</span> -->
               <span class="rich-html" v-html="listItem"></span>
            </li>
          </ul>
        </transition>
      </div>
    </div>
  </section>
</template>

<script>
import accordionData from '../utils/accordionData';
export default {
  name: 'Accomplishments',
  props: {},
  data() {
    return {
      accordionData: accordionData,
      openItems: [],
    };
  },
  methods: {
    toggleAccordion(index) {
      const itemIndex = this.openItems.indexOf(index);
      if (itemIndex > -1) {
        this.openItems.splice(itemIndex, 1);
      } else {
        this.openItems.push(index);
      }
    },
    isOpen(index) {
      return this.openItems.includes(index);
    },
  }
}
</script>

<style lang="scss" scoped>
.accomplishments {
  display: flex;
  flex-direction: column;
  background: $primary-accent;
  padding: 3.75rem 1.5rem 4.125rem;
  &__title {
    font-family: 'Avenir', sans-serif;
    text-align: left;
    font-size: 1.75rem;
    font-weight: 800;
    text-transform: capitalize;
    line-height: 36px;
    margin-bottom: 1.5rem;
    &:before {
      top: -22px;
      background: $black;
      width: 90px;
    }
  }
  &__accordion {
    flex: 1;
    &-item {
      &-header {
        // display: flex;
        // justify-content: space-between;
        // align-items: center;
        cursor: pointer;
        padding: 1rem 0.5rem 1rem 0;
        text-align: left;
        border-bottom: 1px solid $white;
        .chevron {
          background: none;
          border: none;
          cursor: pointer;
          padding: 0;
          margin: 0;
          svg {
            transition: transform 0.3s ease;
          }
          &.rotate {
            svg {
              transform: rotate(180deg);
              transition: transform 0.3s ease;
            }
          }
        }
        &.is-open {
          border: none;
        }
        h3 {
          margin-bottom: 0;
          button {
            background: none;
            border: none;
            cursor: pointer;
            text-align: left;
            font-family: 'Avenir', sans-serif;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            color: #000000;
            span {
              &:first-child {
                font-size: 1.125rem;
                font-weight: 800;
                margin: 0;
              }
              &:last-child {
                display: block;
              }
            }
          }
        }
      }
      &-content {
        &--item {
          text-align: left;
          border-bottom-color: $white;
          padding: 0.625rem 0;
          font-size: 1rem;

          .right-html {
            a {
            background: transparent;
            border: none;
            color: $light-grey;
            cursor: pointer;
            font-size: 1em;
            padding-right: 0;
            padding-left: 0;
            position: relative;
            text-decoration: none;

            background: linear-gradient(
                to bottom,
                $light-grey 0%,
                $light-grey 98%
            );
            background-size: 0px 2px;
            background-repeat: no-repeat;
            background-position: left 100%;
            
            -webkit-transition: all 0.3s ease-out;
            transition: all 0.3s ease-out;
          }
          }
        }
      }
    }
  }
}
@media only screen and (min-width: 768px) {
  .accomplishments {
    padding-top: 5.75rem;
    &__title {
      width: 357px;
      max-width: 15ch;
      font-size: 2.5rem !important;
      line-height: 48px;
      &:before {
      top: -32px;
    }
    }
    &__accordion {
      &-item {
        &--title {
          font-size: 1.5rem;
        }
        &-header {
          h3 {
            button {
              span {
                &:first-child {
                  font-size: 1.5rem;
                }
              }
            }
          }
        }
      }
    }
    &__list {
      li {
        padding: 0.5rem 0 0.5rem 0;

      }
    }
  }
}
@media only screen and (min-width: 1024px) {
  .accomplishments {
    flex-direction: row;
    padding: 5.625rem 10%;
    &__accordion {
      margin-left: 3.5rem;
    }
  }
}
</style>
